<template>
  <div class="row d-flex justify-content-center">
    <div class="col-xl-8">
      <!-- Account Info -->
      <h2 class="content-heading">
        <font-awesome-icon icon="info-circle" fixed-width class="mr-1"/> Account Info
      </h2>
      <div class="row">
        <div class="col-md-6">
          <p>Login Method: <span class="font-weight-bolder">{{currentUser.loginProvider}}</span></p>
        </div>
        <div class="col-md-6">
          <p>Account Tier Level: <span class="font-weight-bolder">{{currentUser.userTier}}</span></p>
        </div>
        <div class="col-md-6">
          <p>Last Login: <span class="font-weight-bolder">{{moment(currentUser.lastSignInTime).format('MMM Do YYYY - h:mm:ss a')}}</span></p>
        </div>
        <div class="col-md-6">
          <p>Account Created: <span class="font-weight-bolder">{{moment(currentUser.creationTime).format('MMM Do YYYY - h:mm:ss a')}}</span></p>
        </div>
      </div>
      <!-- END Account Info -->
      <!-- API Token -->
      <div class="row">
        <div class="col-lg-12">
          <h2 class="content-heading d-flex justify-content-between">
            <span><font-awesome-icon icon="key" fixed-width class="mr-1"/> {{$t('user.profile.apiToken')}}</span>
            <button @click="copyToClipboard" class="btn btn-sm btn-primary" >
              <font-awesome-icon icon="clipboard" fixed-width class="mr-1"/> Copy
            </button>
          </h2>
          <div class="bg-dark rounded p-3 mb-4">
          <pre class="mb-0"><code id="api-token" class="text-body-color-light font-size-sm">
{{currentUser.userApiToken}}
          </code></pre>
          </div>
          <p class="text-muted text-center">API Tokens are valid for <span>{{getTokenValidDays}}</span> days due to security reasons and will be regenerated with every visit.</p>
        </div>
      </div>
      <!-- END API Token -->
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'

export default {
  name: 'profile',
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    getTokenValidDays () {
      if (this.currentUser.userTier === 1) return 1
      else return 30
    }
  },
  data () {
    return {
      moment: moment
    }
  },
  methods: {
    ...mapMutations([
      'setNotification'
    ]),
    copyToClipboard () {
      this.$copyText(this.currentUser.userApiToken)
        .then(() => {
          this.setNotification({
            variant: 'success',
            message: 'Successfully copied API Token to clipboard.'
          })
        })
        .catch((e) => {
          this.setNotification({
            variant: 'danger',
            message: 'Failed to copied API Token to clipboard. Try Again or copy manually.'
          })
        })
    }
  }
}
</script>

<style scoped>
 .bg-image {
   background-image: url("./../../assets/_img/profile-bg.jpg")
 }
</style>
